module.exports = __webpack_public_path__ + "static/media/light-motion-raan-phasing.bc626de.mp4";